import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min.js'

import PageView from 'front/components/PageView/PageView.js'
import Hero from 'front/components/Hero/Hero.js'
import Video from 'front/components/Video/Video.js'
import Quote from 'front/components/Quote/Quote.js'
import ProjectList from 'front/components/ProjectList/ProjectList.js'

import './ProjectListPage.css'
import template from './ProjectListPage.jinja'


var ProjectListPage = PageView.extend({
    el: '.ProjectListPage',

    type: 'ProjectList',

    template: template,

    apiUrl: '/api/pages/work/',

    initialize (options) {
        _.bindAll(this, '_scrollListener', 'animateHeader')

        this.state = new Backbone.Model({inside: false})
        this.scrollListener = _.throttle(this._scrollListener, 100)

        PageView.prototype.initialize.call(this, options)
    },

    _scrollListener() {
        let scrollTop = app.els.$window.scrollTop()

        if (scrollTop / app.els.$window.height() > 0.3) {
            if (!this.state.get('inside')) {
                this.state.set('inside', true)
            }
        } else {
            if (this.state.get('inside')) {
                this.state.set('inside', false)
            }
        }
    },

    animateHeader(state) {
        if (state.get('inside')) {
            app.views.nav.minimize()
            app.views.langs.deactivate()
            this.quote.$el.hide()
            this.hero.deactivateArrow()
        } else {
            app.views.nav.maximize()
            app.views.langs.activate()
            this.quote.$el.show()
            this.hero.activateArrow()
        }
    },

    playIn() {
        this.quote.playIn()
            .then(() => {
                return this.video.playIn()
            })
            .then(() => {
                app.views.nav.activate({fixed: true});
                app.views.cookie.activate();
                this.hero.activateFrame()
                app.views.logo.activate({delay: 500})
                this.hero.activateArrow()
                return app.views.langs.activate({
                    delay: 500,
                    fixed: true
                })
            })
            .then(() => {
                app.els.$body.removeClass('u-NoOverflow')

                this.listenTo(this.state, 'change:inside', this.animateHeader)
                app.els.$window.on('scroll', this.scrollListener)
            })
    },

    playOut() {
        app.views.langs.deactivate()
        app.views.logo.deactivate()
        return Promise.resolve(this.video.playOut())
            .then(() => {
                this.quote.playOut()
                return app.views.nav.deactivate()
            })
    },

    prepare () {
        this.$el[0].style.display = 'block'

        this.$quote = this.$('.Quote')
        this.$video = this.$('.Video')

        this.hero = this.views.hero = new Hero({
            el: this.$('.Hero')
        })

        this.quote = this.views.quote = new Quote({
            el: this.$quote
        })

        this.video = this.views.video = new Video({
            el: this.$video
        })

        this.projectList = this.views.projectList = new ProjectList({
            el: this.$('.ProjectList')
        })

        $.Velocity.hook(this.$quote, 'opacity', '0')
        $.Velocity.hook(this.$video, 'opacity', '0')

        this.hero.$arrow.addClass('isNotActive isNotTransitioned')
        this.hero.$frame.addClass('isNotActive')

        return this.preloadImages()
            .then(() => {
                return this.video.activate()
            })
            .then(() => {
                return this.promise
            })
            .then(() => {
                app.els.$window.scrollTop(0)
                return app.loader.deactivate()
            })
    },

    cleanUp () {
        app.els.$window.off('scroll', this.scrollListener)
        app.els.$body.addClass('u-NoOverflow')
        this.close()
        return app.loader.activate()
    }
})

export default ProjectListPage



// WEBPACK FOOTER //
// ./assets/app/front/pages/ProjectListPage/ProjectListPage.js